export default {
  BUYER_CELL_PHONE: 'cellphone',
  BUYER_ID: 'memberId',
  ORDER_NO: 'orderId'
}



// WEBPACK FOOTER //
// ./src/components/menus/cafe24/enums/OrderListSearchType.js